// Art lives in public/img so the same files can be referenced from CSS,
// canvas and JSX without going through the bundler.
const PUBLIC_URL = process.env.PUBLIC_URL || '';

export const GAME_LOGO = `${PUBLIC_URL}/img/logo.png`;
export const BG_DESKTOP = `${PUBLIC_URL}/img/desktop.jpg`;
export const BG_MOBILE = `${PUBLIC_URL}/img/mobile.jpg`;
export const EM_LOGO = process.env.REACT_APP_EM_LOGO || '';

/**
 * The backgrounds are handed to CSS as custom properties because CRA's
 * css-loader tries to bundle root-relative url() paths, which fails for
 * files that live in public/.
 */
export function applyBackgroundVars() {
  const root = document.documentElement;
  root.style.setProperty('--bg-desktop', `url("${BG_DESKTOP}")`);
  root.style.setProperty('--bg-mobile', `url("${BG_MOBILE}")`);
}
